import React, { FunctionComponent } from 'react';

type CompanyInfoHeaderProps = {
  companyId: number;
  companyName: string;
  companyIcon: string;
  noImagePath: string;
};

export const Presentation: FunctionComponent<CompanyInfoHeaderProps> = ({
  companyId,
  companyName,
  companyIcon,
  noImagePath
}) => {
  return (
    <div className="hero-label">
      <a href={`/companies/${companyId}`} className="hero-label-author-link">
        <div className="hero-label-author-img">
          <img src={companyIcon || noImagePath} alt={companyName} width={60} height={60}/>
        </div>
        <div className="hero-label-author-name">{companyName}</div>
      </a>
    </div>
  );
};
